var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "255px",
    viewBox: "0 0 256 255",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.7503645%",
    y1: "111.399353%",
    x2: "58.2543962%",
    y2: "64.5837087%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E42B1E",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990000",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "116.651024%",
    y1: "60.8903211%",
    x2: "1.74616041%",
    y2: "19.2879503%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.7744024%",
    y1: "219.327131%",
    x2: "38.9781357%",
    y2: "7.82868176%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911209",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.012428%",
    y1: "7.23449921%",
    x2: "66.4830414%",
    y2: "79.1354134%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57252",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3B20",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60003",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60003",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.1741749%",
    y1: "16.347907%",
    x2: "49.9323342%",
    y2: "83.0468449%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4714E",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1A0D",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.9653573%",
    y1: "15.5936471%",
    x2: "49.5282324%",
    y2: "92.4776332%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46342",
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82410",
    offset: "40%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.6086166%",
    y1: "58.3456855%",
    x2: "85.7636612%",
    y2: "-46.7167814%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C81F11",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0905",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF0905",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.6242038%",
    y1: "21.1345847%",
    x2: "50.7445145%",
    y2: "79.0557818%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4024",
    offset: "31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF190B",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF190B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.6671297%",
    y1: "122.281897%",
    x2: "104.241521%",
    y2: "-6.34211007%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C82F1C",
    offset: "27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#820C01",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31601",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31301",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82609",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82609",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.7919609%",
    y1: "65.2049657%",
    x2: "11.9636556%",
    y2: "50.1275621%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990C00",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D0E",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D0E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "79.3194899%",
    y1: "62.7538068%",
    x2: "23.088288%",
    y2: "17.8876818%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0C00",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E0C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.8800277%",
    y1: "74.1223655%",
    x2: "59.8414537%",
    y2: "39.7039965%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E120B",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E120B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "32.0008013%",
    cy: "40.2100469%",
    fx: "32.0008013%",
    fy: "40.2100469%",
    r: "69.5729556%",
    id: "radialGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E0E08",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E0E08",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "13.5493795%",
    cy: "40.859922%",
    fx: "13.5493795%",
    fy: "40.859922%",
    r: "88.3861936%",
    id: "radialGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800E08",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800E08",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.5701955%",
    y1: "101.716594%",
    x2: "3.10480737%",
    y2: "11.9932603%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E100A",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3100C",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3100C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.8698732%",
    y1: "35.5989756%",
    x2: "92.4707626%",
    y2: "100.693616%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#910F08",
    offset: "44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791C12",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#791C12",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M197.467337,167.763618 L51.9461307,254.173266 L240.368563,241.387417 L254.880804,51.3929648 L197.467337,167.763618 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.677307,241.257487 L224.482412,129.479397 L180.369367,187.729045 L240.677307,241.257487 Z",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.896,241.257487 L122.249648,231.943719 L52.5764824,253.930131 L240.896,241.257487 Z",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7437186,253.954573 L82.3831156,156.854673 L17.161005,170.800884 L52.7437186,253.954573 Z",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.357789,188.050653 L153.085427,81.2253266 L75.0375879,154.384724 L180.357789,188.050653 Z",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.693065,82.7304523 L174.916181,22.4739698 L154.371859,88.8924623 L248.693065,82.7304523 Z",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.190955,0.990552764 L170.799598,24.9696482 L143.424322,0.668944724 L214.190955,0.990552764 Z",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,203.37206 L18.1772864,170.220704 L3.47336683,130.727236 L0,203.37206 Z",
    fill: "url(#linearGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49567839,129.479397 L17.2896482,171.442814 L81.5726633,157.020623 L154.963618,88.8139899 L175.675176,23.0271357 L143.062834,0 L87.617608,20.7501508 C70.1491457,36.9977889 36.2516583,69.1457286 35.0295477,69.7503518 C33.8203015,70.3678392 12.6456281,110.388744 2.49567839,129.479397 L2.49567839,129.479397 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.441809,54.0944724 C92.3015075,16.5563819 141.108744,-5.62170854 159.839196,13.2759799 C178.55807,32.1736683 158.707136,78.0992965 120.847437,115.624523 C82.9877387,153.149749 34.7851256,176.54995 16.0675377,157.652261 C-2.66291457,138.767437 16.5821106,91.6196985 54.441809,54.0944724 L54.441809,54.0944724 Z",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7437186,253.91598 L82.1515578,156.507337 L179.817487,187.883417 C144.504925,220.996181 105.230151,248.988945 52.7437186,253.91598 L52.7437186,253.91598 Z",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.092261,88.6223116 L180.164824,187.934874 C209.662714,156.918995 236.137487,123.574673 249.103437,82.3316583 L155.092261,88.6223116 L155.092261,88.6223116 Z",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.847437,82.8333668 C258.881608,52.5507538 261.197186,9.1079397 213.880925,1.04201005 L175.056402,22.4868342 L248.847437,82.8333668 L248.847437,82.8333668 Z",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,202.934673 C1.38934673,252.913849 37.4480402,253.658693 52.8080402,254.097367 L17.3282412,171.236985 L0,202.934673 L0,202.934673 Z",
    fill: "#9E1209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.232482,88.7766834 C177.899417,102.708744 223.58191,130.688643 224.508141,131.203216 C225.947658,132.013668 244.203417,100.418894 248.345729,82.5632161 L155.232482,88.7766834 L155.232482,88.7766834 Z",
    fill: "url(#radialGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1129648,156.507337 L121.426332,232.355377 C144.672161,219.748342 162.875176,204.388342 179.547337,187.934874 L82.1129648,156.507337 L82.1129648,156.507337 Z",
    fill: "url(#radialGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1738693,171.339899 L11.6036181,237.668342 C22.1137688,252.024925 36.5732663,253.272764 51.7403015,252.153568 C40.7670352,224.842613 18.8462312,170.233568 17.1738693,171.339899 L17.1738693,171.339899 Z",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.826131,22.6540704 L252.925427,33.6144724 C248.757387,15.9517588 235.957387,4.55396985 214.139497,0.990552764 L174.826131,22.6540704 L174.826131,22.6540704 Z",
    fill: "url(#linearGradient-16)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.67bc5facad6cfa03aaafadcab5d0a4a3.svg";
export { ForwardRef as ReactComponent };